module.exports = __webpack_public_path__ + "static/media/footer-address-icon.b9141556.png";